export const PRIMITIVE_TYPES = [
    "undefined",
    "number",
    "string",
    "boolean",
    "symbol",
];
